export default __webpack_public_path__ + "static/media/sandero-gallery-14.8e0f46aa.jpg";